"use strict";

exports.__esModule = true;
exports.default = void 0;

var _pagination = _interopRequireDefault(require("./pagination"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BPagination: _pagination.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/pagination/index.js
// module id = 412
// module chunks = 0